import { VoterInterface, VoterInterfaceConstants } from '../voter-interface';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class OrganizationRoleVoter implements VoterInterface {
    constructor(
        private currentUserRolesProvider: CurrentUserRolesProvider,
    ) {

    }

    public vote(currentUser: any, attributes: any, subject: any): number {
        // abstain vote by default in case none of the attributes are supported
        let vote = VoterInterfaceConstants.ACCESS_ABSTAIN;

        if (!currentUser.hasOwnProperty('organization')) {
            return vote;
        }

        if (!currentUser.organization) {
            return vote;
        }

        const roles = this.currentUserRolesProvider.getRolesIds(currentUser.organization.id);

        for (const attribute of attributes) {
            // as soon as at least one attribute is supported, default is to deny access
            vote = VoterInterfaceConstants.ACCESS_DENIED;

            // grant user if matches at least one current user role
            for (const roleId of roles) {
                if (attribute === roleId) {
                    return VoterInterfaceConstants.ACCESS_GRANTED;
                }
            }
        }

        return vote;
    }
}
